import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Input from '@ls/react-input';
import { setTickerFilter } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';
import {
  selectSelectedTickerFiltervalues
} from 'state/selections/selectors';

const TickerTextFilter = (props) => {
const dispatch = useDispatch();
const values = useSelector(
  selectSelectedTickerFiltervalues(SelectionState.UNCOMMITTED)
);
const onChange = React.useCallback(
  tickers => {
    dispatch(setTickerFilter(tickers?.toUpperCase()));
  },
  [dispatch]
);
  return (
    <Input
      label="Tickers"
      value={values ?? ""}
      onChange={onChange}
      variation={2}
      placeholder="Comma Separated Tickers..."
    />
  );
};

TickerTextFilter.propsTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TickerTextFilter;